module.exports = __webpack_public_path__ + "static/kitchen-f1b604e73a0975708f8024d1241a5bfe.jpg";